import { useEffect } from "react";
import { useAuthStore } from "../store/authStore";

/**
 * Componente invisible que restaura la sesión al cargar la app.
 *
 * Llama /auth/me y, si es necesario, /auth/refresh para recuperar:
 *  - el usuario autenticado
 *  - el CSRF token en memoria (imprescindible para peticiones mutativas)
 *
 * Se monta una sola vez en App.tsx, antes de las rutas.
 */
export function AuthInitializer() {
	const checkAuth = useAuthStore((s) => s.checkAuth);

	useEffect(() => {
		checkAuth();
	}, [checkAuth]);

	return null;
}
